export default __webpack_public_path__ + "static/media/phonebrown.982f11e8.svg";